// @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'Workflow'. Did you mean to use 'import Workflow from "src/api-parsers/index"' instead?
import type {Workflow} from 'src/api-parsers/index';
import type {ModalType} from 'src/components/modals/modal-root';

import * as React from 'react';

import FluxComponent from 'src/flux/component';
import {TitleBarModal} from 'src/components/modals/base-modal';

import {deleteCurrentEvent} from 'src/actions/event-creation';

import WarningIcon from 'src/images/icons/warning-icon.svg?noAttrs';

import css from 'src/components/modals/base-modal.css';

// @ts-expect-error - TS7031 - Binding element 'store' implicitly has an 'any' type. | TS7031 - Binding element 'id' implicitly has an 'any' type.
const mapper = ({store, workflow: {id}}) => ({
  deletingEvent: Boolean(store.request.inProgress(`deleteCurrentEvent/${id}`)),
});

class EventDeleteModal extends React.Component<{
  store: any;
  router: any;
  workflow: Workflow;
  eventId: string;
  removeModal: () => void;
  deletingEvent: boolean;
  type: ModalType;
  handleDelete?: () => {
    then: (arg1: unknown) => unknown;
  };
}> {
  constructor(props: any) {
    super(props);

    (this as any).handleDelete = this.handleDelete.bind(this);
  }

  // @ts-expect-error - TS4114 - This member must have an 'override' modifier because it overrides a member in the base class 'Component<{ store: any; router: any; workflow: Workflow; eventId: string; removeModal: () => void; deletingEvent: boolean; type: any; handleDelete?: (() => { then: (arg1: unknown) => unknown; }) | undefined; }, {}, any>'.
  render() {
    const {
      workflow: {active},
      removeModal,
      deletingEvent,
      type,
    } = this.props;

    const headingText = active
      ? 'Can\'t Delete an Active Touchpoint'
      : 'Really delete this touchpoint?';
    const explanationText = active
      ? 'Please de-activate your journey before deleting a touchpoint.'
      : 'Once you delete it, all touchpoint modules and scheduling \
        information will be lost but analytics will be retained.';

    return (
      <TitleBarModal
        type={type}
        title={headingText}
        text={explanationText}
        confirmText={active ? '' : deletingEvent ? 'Deleting...' : 'Delete it'}
        abortText={active ? 'OK' : 'Cancel'}
        handleConfirm={this.handleDelete}
        handleAbort={removeModal}
        // @ts-expect-error - TS2322 - Type '{ style: { fill: string; }; }' is not assignable to type 'IntrinsicAttributes'.
        titleIcon={<WarningIcon style={{fill: css.colorWhite}} />}
      />
    );
  }

  handleDelete(event: React.SyntheticEvent) {
    event.preventDefault();

    const {
      store,
      router,
      workflow: {id},
      removeModal,
      handleDelete,
    } = this.props;

    const handleDeleteSuccess = () => {
      router.replace(`/journey/${id}`);
      removeModal();
    };

    if (handleDelete) {
      handleDelete().then(handleDeleteSuccess);
    } else {
      // @ts-expect-error - TS18046 - 'deleteCurrentEvent' is of type 'unknown'.
      deleteCurrentEvent(store, id).then(handleDeleteSuccess);
    }
  }
}

export default FluxComponent(
  EventDeleteModal,
  mapper,
) as React.ComponentType<any>;
